import { event } from '@abyss/web/tools/event';

export const adobeModalTrackEvent = (name) => {
  event('MODAL_TRACK_EVENT', {
    modal: {
      name: name.toLowerCase().replaceAll('-', ' '),
    },
  });
};
